/*jshint esversion: 11 */

import PreparePayload from "./PreparePayload";
import { credKey, taskId } from "../config";


export default async function submitDataToParent ( data ) {
    const payload = PreparePayload( data );
    payload.credKey  = credKey;

    const message = {
        type: 'fma-payload',
        payload: payload,
        taskId: taskId
    };

    window.parent.postMessage( message, '*' );

    return { status: 200 };
}
